/* ============================================================
   CALCULATEUR CHARGE ADMISSIBLE RAYONNAGE — hero DA (fiche 2 zones)
   charge totale = charge/niveau × niveaux × travées.
   ⚠️ Estimation indicative — voir plaque de charge / EN 15635 (disclaimer).
   ============================================================ */
(function () {
  'use strict';
  const root = document.getElementById('calc-charge-root');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const cNiveau = $('#ch-niveau');
  const niveaux = $('#ch-niveaux');
  const travees = $('#ch-travees');
  const btn = $('#ch-go');
  const results = $('#ch-results');
  const summary = $('#ch-summary');

  const fmt = (n) => Math.round(n).toLocaleString('fr-FR');
  const fmtT = (kg) => (kg / 1000).toFixed(1).replace('.', ',');
  const arrow = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';
  const pencil = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4z"/></svg>';

  function showForm() { root.classList.remove('is-calculated'); results.hidden = true; cNiveau.focus(); }

  function calculate() {
    const cn = parseFloat(cNiveau.value);
    const N = parseInt(niveaux.value, 10), T = parseInt(travees.value, 10);
    if (!cn || !N || !T || cn <= 0 || N <= 0 || T <= 0) {
      root.classList.remove('is-calculated'); results.hidden = true;
      [cNiveau, niveaux, travees].forEach((i) => { if (!i.value) i.reportValidity && i.reportValidity(); });
      return;
    }
    const parTravee = cn * N;
    const totale = parTravee * T;

    const left =
      '<div class="ch-zone ch-zone-left">' +
        '<p class="ch-r-eyebrow ch-reveal">Charge admissible (indicative)</p>' +
        '<p class="ch-r-total ch-reveal"><span>' + fmtT(totale) + '</span><i class="ch-r-unit">tonnes</i></p>' +
        '<p class="ch-r-sub ch-reveal">' + fmt(cn) + ' kg/niveau · ' + N + ' niveaux · ' + T + ' travées</p>' +
        '<div class="ch-lines ch-reveal ch-r2">' +
          '<div class="ch-line"><span class="ch-line-k">Charge / niveau</span><span class="ch-line-v">' + fmt(cn) + ' kg</span></div>' +
          '<div class="ch-line"><span class="ch-line-k">Charge / travée</span><span class="ch-line-v">' + fmt(parTravee) + ' kg</span></div>' +
          '<div class="ch-line ch-line--em"><span class="ch-line-k">Charge totale</span><span class="ch-line-v">' + fmt(totale) + ' kg</span></div>' +
        '</div>' +
      '</div>';

    const right =
      '<div class="ch-zone ch-zone-right ch-reveal ch-r3">' +
        '<span class="ch-badge">Sécurité · EN 15635</span>' +
        '<h3 class="ch-reco-h">Faites valider votre installation</h3>' +
        '<p class="ch-reco-d">Cette estimation suppose une charge/niveau homogène. La capacité réelle dépend des lisses, échelles, hauteur du 1ᵉʳ niveau et de l’état du rack.</p>' +
        '<ul class="ch-stats">' +
          '<li><span>Charge / niveau</span><b>' + fmt(cn) + ' kg</b></li>' +
          '<li><span>Charge / travée</span><b>' + fmt(parTravee) + ' kg</b></li>' +
          '<li class="win"><span>Charge totale</span><b>' + fmtT(totale) + ' T</b></li>' +
          '<li><span>Référence</span><b>Plaque de charge</b></li>' +
        '</ul>' +
        '<a href="/pages/devis" class="ds-cta-btn ds-cta-btn-primary ch-rcta">Étude technique gratuite ' + arrow + '</a>' +
        '<p class="ch-rnote">Estimation indicative — ne remplace pas la plaque de charge ni une vérification structurelle (EN 15635).</p>' +
      '</div>';

    results.innerHTML = '<div class="ch-rbody">' + left + right + '</div>';
    results.hidden = false;
    summary.innerHTML =
      '<span class="ch-sum-tag">Votre rack</span>' +
      '<div class="ch-summary-chips">' +
        '<span class="ch-chip">' + fmt(cn) + ' kg/niveau</span>' +
        '<span class="ch-chip">' + N + ' niveaux</span>' +
        '<span class="ch-chip">' + T + ' travées</span>' +
      '</div>' +
      '<button type="button" class="ch-modify" id="ch-modify">' + pencil + 'Modifier</button>';
    root.classList.add('is-calculated');
    const mod = $('#ch-modify'); if (mod) mod.addEventListener('click', showForm);
  }

  btn.addEventListener('click', calculate);
  [cNiveau, niveaux, travees].forEach((i) => i.addEventListener('keypress', (e) => { if (e.key === 'Enter') calculate(); }));
})();
